module.exports = __webpack_public_path__ + "img/g6.dce5cfb5.jpg";